export default {
    namespaced: true,
    state: {
        counties: null,
    },
    mutations: {
        setCounties: (state, counties) => {
            state.counties = counties;
        },
    },
    actions: {
        getCounties(context) {
            return this.$axios.get('/counties')
                .then(response => {
                    if(response.data.counties) {
                        context.commit('setCounties', response.data.counties);
                    }

                    return response;
                });
        },
    },
    getters: {
        getCounties: (state) => {
            return state.counties;
        },
    }
}
